var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-2.5 py-0.5 inline-flex items-center rounded-full font-medium leading-4",class:_vm.badgeClass},[_vm._v(" "+_vm._s(_vm.badgeLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }